// Where the reviewer was when they opened Patient Details from the session
// workspace, so coming back (Patient Details' Back → My Tasks) lands on the
// same session, patient and view. Read once, then cleared.
const RESUME_KEY = "reading-review/resume-point";

export const saveResumePoint = ({ accId, sessionId, patientId, readingType, listOpen }) => {
  sessionStorage.setItem(
    RESUME_KEY,
    JSON.stringify({ accId: String(accId), sessionId, patientId, readingType, listOpen })
  );
};

export const takeResumePoint = () => {
  try {
    const point = JSON.parse(sessionStorage.getItem(RESUME_KEY) || "null");
    sessionStorage.removeItem(RESUME_KEY);
    // Only for the account the app is on now.
    return point && point.accId === String(sessionStorage.getItem("acc_id")) ? point : null;
  } catch {
    return null;
  }
};
